
import React, { useState, useEffect, useRef } from "react";
import clsx from "clsx";
import { ProductSearch, getAllBrandProduct } from '../generatedRequest/product';
import MasterCustomTooltip from "../utils/CustomStyleComponent/MasterModelTooltip";
import AttributeAccordion from "./AttributeAccordion";
import { removeProduct } from '../generatedRequest/master'

import "./indicator.css";

import CustomArrow from "../utils/CustomStyleComponent/ArrowComponent";
import CustomTooltip1 from "../utils/CustomStyleComponent/TooltipNewComponent";
import { getProductGroupByBrand, getProductByProductGroup, getProductByPowerGroup } from "../generatedRequest/master";
import Multiselect from "multiselect-react-dropdown";
import CustomCrossButton from "../utils/CustomStyleComponent/CrossButtonComponent";
import MasterModelSelector from "./MasterModelSelector";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const normalizeAttributeValue = (value: string | undefined | null): string => {
    if (!value) return '-';
    let normalized = value.toLowerCase().trim();
    if (['y', 'yes', 'true'].includes(normalized)) {
        return 'yes';
    }
    normalized = normalized
        .replace(/\s*(pixels|px|mm|cm|inch|in|gb|tb|mb|hz|ghz|mhz|mah|w|wh|°|deg|degrees)\b/gi, '')
        .trim();

    return normalized;
};

const EditMasterForm = ({
    product,
    formik,
    isEdit,
    masterData,
    productData,
    onFormDataChange,
    onSyncEdit,
    data,
}: {

    product: any;
    formik: any;
    isEdit: any;
    masterData: any;
    productData: any;
    onFormDataChange?: (data: any) => void;
    onSyncEdit?: (syncData: any) => void;
    data: any;
}) => {
    const navigate = useNavigate();
    const [perPageRecords, setPerPageRecords] = useState(100);
    const [productName, setProductName] = useState("");
    const [productId, setProductId] = useState<number | null>(null);
    const [productSuggestions, setProductSuggestions] = useState<any[]>([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [keyword, setKeyword] = useState("");
    const [selectedProducts, setSelectedProducts] = useState<{ id: number;[key: string]: any }[]>([]);
    const [mergedData, setMergedData] = useState<any[]>([]);
    const [productSearchTerm, setProductSearchTerm] = useState("");
    const [masterModel, setMasterModel] = useState<{
        id: number | null;
        displayName: string | null;
        productName: string | null;
        modelNumber: string | null;
        attributes: [] | null;
    }>({
        id: null,
        displayName: null,
        productName: null,
        modelNumber: null,
        attributes: null,
    });
    const style = {
        multiSelectContainer: {
            minheight: "44px",
            border: "1px solid var(--bs-gray-100)",
        },
        searchBox: {
            minheight: "44px",
            fontWeight: "500",
            minwidth: "40px",
            maxwidth: "40px",
            height: "44px",
            display: "flex",
            alignItems: "center",
        },
        chips: {
            marginBottom: "0",
        },
    };
    const [uniqueAttributes, setUniqueAttributes] = useState<string[]>([]);
    const [selectedAttributes, setSelectedAttributes] = useState<string[]>([]);
    const [productsToRemove, setProductsToRemove] = useState<string[]>([]);
    const [productInfo, setProductInfo] = useState<any[]>([]);
    const [updatedproductData, setUpdatedproductData] = useState<any[]>([])
    const [allBrand, setAllBrand] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState("");
    const [allProductGroups, setAllProductGroups] = useState<any[]>([]);
    const [selectedValue, setSelectedValue] = useState('');
    const [selectedProductGroup, setSelectedProductGroup] = useState<any>({});
    const [totalProductShown, setTotalProductShown] = useState<any>(0);
    const [showFilterType, setShowFilterType] = useState('all');
    const [powerGroups, setPowerGroups] = useState<any[]>([]);
    const allProductGroupsWithCount = allProductGroups.map((item) => ({
        ...item,
        labelWithCount: `${item.label} (${item.count})`
    }));
    const searchContainerRef = useRef<HTMLDivElement | null>(null);
    const [productInfoFilters, setProductInfoFilters] = useState<{ [key: string]: string[] }>({});
    const [availablePowerValues, setAvailablePowerValues] = useState<string[]>([]);
    const [selectedPowerValues, setSelectedPowerValues] = useState<string[]>([]);
    const [uniqueAcAdapterPowerValues, setUniqueAcAdapterPowerValues] = useState([]);

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (
                searchContainerRef.current &&
                searchContainerRef.current.contains &&
                !searchContainerRef.current.contains(event.target)
            ) {
                setShowSuggestions(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleFormDataChange = (data: { keyword: string, masterModel: any, updatedProducts?: any[] }) => {
        formik.setFieldValue("keyword", data.keyword || '');
        formik.setFieldValue("masterModel", data.masterModel || {});
        if (data.updatedProducts && data.updatedProducts.length > 0) {
            handleProductUpdateSuccess(data.updatedProducts);
        }
    };

    useEffect(() => {
        if (product) {
            if (product.productName) {
                setProductName(product.productName);
            }
            if (product.id) {
                setProductId(product.id);
            }
            if (product.keyword) {
                setKeyword(product.keyword);
            }
        }
    }, [product, masterData, isEdit]);

    // Third input functionality
    const handleAttributeSelection = (attributeName: string) => {
        setSelectedAttributes(prev => {
            if (prev.includes(attributeName)) {
                // Remove if already selected
                return prev.filter(attr => attr !== attributeName);
            } else {
                // Add if not selected
                return [...prev, attributeName];
            }
        });
    };

    const handleBrandFilter = async (data: any) => {
        setIsLoading(true);
        setSelectedBrand(data[0].brandName);
        const response = await getProductGroupByBrand(data[0].brandName);
        if (response.data.status) {
            setAllProductGroups(response.data.data);
            setIsLoading(false);
        } else {
            console.error("Something went wrong");
            setIsLoading(false);
        }
    }

    const handleProductFamilyFilter = async (data: any, offset = 0, perPageRecords = 100) => {
        console.log('handleProductFamilyFilter called with:', { data, offset, perPageRecords });
        setIsLoading(true);
        if (offset === 0 &&
            data.length === 0) {
            setAllProductGroups([]);
            setSelectedProducts([]);
            setProductsToRemove([]);
            return;
        }

        if (offset === 0) {
            setSelectedProducts([]);
            setProductInfo([]);
        }
        

        const selectedGroup = data[0] || data;
        const productFamily = selectedGroup.label;
        selectedGroup.shownProducts = offset + perPageRecords
        setSelectedProductGroup(selectedGroup);
        setTotalProductShown(offset + perPageRecords);

        const response = await getProductByProductGroup(selectedBrand, productFamily, offset, perPageRecords);
        if (response.data.status) {

            console.log(response.data.data)
            // const productData = response.data.data.products;
            const uniqueValue = response.data.data.uniqueAcAdapterPowerValues
            // console.log(productData, "product")
            setUniqueAcAdapterPowerValues(uniqueValue || []);


            /* const productData = response.data.data;
            console.log(productData , "productData")
            const existingProductIds = new Set(selectedProducts.map(p => p._id || p.id));

            const newProducts = productData.filter((item: any) => {
                const productId = item._id || item.id;
                return !existingProductIds.has(productId);
            }).map((item: any) => ({
                ...item,
                id: item._id || item.id || `product-${Date.now()}`
            }));

            setSelectedProducts(prev => {
                const existingIds = prev.map(p => p.id);
                const uniqueNewProducts = newProducts.filter((p: any) => !existingIds.includes(p.id));
                const updatedProducts = [...prev, ...uniqueNewProducts];

                const allAttributeNames = updatedProducts
                    .filter(product => product.attributes && Array.isArray(product.attributes) && product.attributes.length > 0)
                    .flatMap(product =>
                        product.attributes.map((attr: any) => {
                            if (typeof attr === 'string') {
                                return attr;
                            }
                            if (typeof attr === 'object' && attr.attributeName) {
                                return attr.attributeName;
                            }
                            return null;
                        })
                    )
                    .filter(name => name !== null && name !== undefined && name !== '');

                const uniqueAttributeNames = Array.from(new Set(allAttributeNames));
                setUniqueAttributes(uniqueAttributeNames);
                return updatedProducts;
            });

            if (offset === 0) {
                const filteredProductsData = newProducts.map((product: any, productIndex: number) => {
                    return {
                        _id: product._id,
                        displayName: product.displayName || '',
                        productName: product.productName || '',
                        modelNumber: product.modelNumber || '',
                        attributes: selectedAttributes.map(attributeName => {
                            const attributeObject = product.attributes?.find((attr: any) => {
                                if (typeof attr === 'object' && attr.attributeName) {
                                    return attr.attributeName === attributeName;
                                }
                                return false;
                            });

                            if (attributeObject) {
                                return {
                                    attributeName: attributeObject.attributeName,
                                    value: attributeObject.value || '-',
                                    unit: attributeObject.unit || {},
                                    _id: attributeObject._id || null
                                };
                            } else {
                                return {
                                    attributeName: attributeName,
                                    value: '-',
                                    unit: {},
                                    _id: null
                                };
                            }
                        }).filter(attr => attr !== null)
                    };
                });

                setProductInfo(filteredProductsData);
            } else {
                setProductInfo(prev => {
                    const newFilteredProducts = newProducts.map((product: any) => ({
                        _id: product._id,
                        displayName: product.displayName || '',
                        productName: product.productName || '',
                        modelNumber: product.modelNumber || '',
                        attributes: selectedAttributes.map(attributeName => {
                            const attributeObject = product.attributes?.find((attr: any) => {
                                if (typeof attr === 'object' && attr.attributeName) {
                                    return attr.attributeName === attributeName;
                                }
                                return false;
                            });

                            if (attributeObject) {
                                return {
                                    attributeName: attributeObject.attributeName,
                                    value: attributeObject.value || '-',
                                    unit: attributeObject.unit || {},
                                    _id: attributeObject._id || null
                                };
                            } else {
                                return {
                                    attributeName: attributeName,
                                    value: '-',
                                    unit: {},
                                    _id: null
                                };
                            }
                        }).filter(attr => attr !== null)
                    }));

                    return [...prev, ...newFilteredProducts];
                });
            } */

            setIsLoading(false);
            //setProductsToRemove([]);
        } else {
            console.error("Something went wrong");
            setIsLoading(false);
        }
    };

 console.log("Console:",  selectedBrand, powerGroups,  );
    const handleAddPowerGroups = async (selectedBrand: string, powerGroups: string[], offset = 0, perPageRecords = 100) => {
        setIsLoading(true);
    console.log("Calling API with:", { selectedBrand, powerGroups, offset, perPageRecords });
        if (!selectedBrand || powerGroups.length === 0) {
            console.error("Brand and power values are required");
            setIsLoading(false);
            return;
        }

        try {
        

            const response = await getProductByPowerGroup(
                selectedBrand,
                powerGroups,
                offset,
                perPageRecords
            );

            // console.log("API Response:", response);
            if (response.data.status) {

                console.log(response.data.data)
                const productData = response.data.data;
                const uniqueValue = response.data.data.uniqueAcAdapterPowerValues
                console.log(productData, "product")
                setUniqueAcAdapterPowerValues(uniqueValue || []);


                
          
                const existingProductIds = new Set(selectedProducts.map(p => p._id || p.id));
    
                const newProducts = productData.filter((item: any) => {
                    const productId = item._id || item.id;
                    return !existingProductIds.has(productId);
                }).map((item: any) => ({
                    ...item,
                    id: item._id || item.id || `product-${Date.now()}`
                }));
    
                setSelectedProducts(prev => {
                    const existingIds = prev.map(p => p.id);
                    const uniqueNewProducts = newProducts.filter((p: any) => !existingIds.includes(p.id));
                    const updatedProducts = [...prev, ...uniqueNewProducts];
    
                    const allAttributeNames = updatedProducts
                        .filter(product => product.attributes && Array.isArray(product.attributes) && product.attributes.length > 0)
                        .flatMap(product =>
                            product.attributes.map((attr: any) => {
                                if (typeof attr === 'string') {
                                    return attr;
                                }
                                if (typeof attr === 'object' && attr.attributeName) {
                                    return attr.attributeName;
                                }
                                return null;
                            })
                        )
                        .filter(name => name !== null && name !== undefined && name !== '');
    
                    const uniqueAttributeNames = Array.from(new Set(allAttributeNames));
                    setUniqueAttributes(uniqueAttributeNames);
                    return updatedProducts;
                });
    
                if (offset === 0) {
                    const filteredProductsData = newProducts.map((product: any, productIndex: number) => {
                        return {
                            _id: product._id,
                            displayName: product.displayName || '',
                            productName: product.productName || '',
                            modelNumber: product.modelNumber || '',
                            attributes: selectedAttributes.map(attributeName => {
                                const attributeObject = product.attributes?.find((attr: any) => {
                                    if (typeof attr === 'object' && attr.attributeName) {
                                        return attr.attributeName === attributeName;
                                    }
                                    return false;
                                });
    
                                if (attributeObject) {
                                    return {
                                        attributeName: attributeObject.attributeName,
                                        value: attributeObject.value || '-',
                                        unit: attributeObject.unit || {},
                                        _id: attributeObject._id || null
                                    };
                                } else {
                                    return {
                                        attributeName: attributeName,
                                        value: '-',
                                        unit: {},
                                        _id: null
                                    };
                                }
                            }).filter(attr => attr !== null)
                        };
                    });
    
                    setProductInfo(filteredProductsData);
                } else {
                    setProductInfo(prev => {
                        const newFilteredProducts = newProducts.map((product: any) => ({
                            _id: product._id,
                            displayName: product.displayName || '',
                            productName: product.productName || '',
                            modelNumber: product.modelNumber || '',
                            attributes: selectedAttributes.map(attributeName => {
                                const attributeObject = product.attributes?.find((attr: any) => {
                                    if (typeof attr === 'object' && attr.attributeName) {
                                        return attr.attributeName === attributeName;
                                    }
                                    return false;
                                });
    
                                if (attributeObject) {
                                    return {
                                        attributeName: attributeObject.attributeName,
                                        value: attributeObject.value || '-',
                                        unit: attributeObject.unit || {},
                                        _id: attributeObject._id || null
                                    };
                                } else {
                                    return {
                                        attributeName: attributeName,
                                        value: '-',
                                        unit: {},
                                        _id: null
                                    };
                                }
                            }).filter(attr => attr !== null)
                        }));
    
                        return [...prev, ...newFilteredProducts];
                    });
                } 

                setIsLoading(false);
                //setProductsToRemove([]);
            } else {
                console.error("Something went wrong");
                setIsLoading(false);
            }
        } catch (error) {
            console.error("API call failed:", error);
            setIsLoading(false);
        }
    };


    useEffect(() => {
        handleProductFamilyFilter(selectedProductGroup);
    }, [selectedProductGroup]);
    useEffect(() => {
        if (uniqueAcAdapterPowerValues.length > 0) {
            console.log(powerGroups, "powerGroups");
            const stripCount = (str: string) => {
                // Remove the last " (number)" part if present
                return str.replace(/\s\(\d+\)$/, '').trim();
            };

            const filteredValues = uniqueAcAdapterPowerValues.filter(
                (val) => {
                    const labelWithoutCount = stripCount(val);
                    // Check if this label (without count) is NOT in powerGroups
                    return !powerGroups.includes(labelWithoutCount);
                }
            );
            setAvailablePowerValues(filteredValues);
           
        }
    }, [uniqueAcAdapterPowerValues]);

    const handleSelectPowerValue = (powerValue: string) => {
        setSelectedPowerValues(prev => [...prev, powerValue]);
        setPowerGroups(prev => [...prev, powerValue]);
        setAvailablePowerValues(prev => prev.filter(value => value !== powerValue));
    };

    
    
    useEffect(() => {
        setProductsToRemove([]);
    }, [showFilterType]);

    useEffect(() => {
        setProductsToRemove([]);
    }, [selectedAttributes]);

    const handleSelectChange = (index: any, value: any) => {
        setSelectedValue((prev: any) => ({
            ...prev,
            [index]: value,
        }));
    };

    useEffect(() => {
        if (masterData && masterData.ProductInfo) {
            setProductInfo(prev => {
                return prev.map(product => ({
                    ...product,
                }));
            });
        }
    }, [masterData]);

    useEffect(() => {
        const fetchAllBrand = async () => {
            try {
                const response = await getAllBrandProduct();
                if (response.data.status) {
                    setAllBrand(response.data.data);
                } else {
                    console.error("Something went wrong");
                }
            } catch (error) {
                console.error("Network Error");
            }
        };

        fetchAllBrand();
    }, []);

    const handleProductRemovalSelection = (productId: string) => {
        setProductsToRemove(prev => {
            if (prev.includes(productId)) {
                return prev.filter(id => id !== productId);
            } else {
                return [...prev, productId];
            }
        });
    };

    const handleSelectAllForRemoval = (checked: boolean) => {
        const filteredProducts = getFilteredProductInfo();
        if (checked) {
            const allProductIds = filteredProducts.map((product, index) =>
                product._id?.toString() || product.id?.toString() || `product-${index}`
            );
            setProductsToRemove(allProductIds);
        } else {
            setProductsToRemove([]);
        }
    };

    const isProductSelectedForRemoval = (productId: string) => {
        return productsToRemove.includes(productId);
    };

    const areAllProductsSelectedForRemoval = () => {
        const filteredProducts = getFilteredProductInfo();
        if (filteredProducts.length === 0) return false;
        return filteredProducts.every(product => {
            const productId = product._id?.toString() || product.id?.toString();
            return isProductSelectedForRemoval(productId);
        });
    };

    const handleRemoveSelectedProducts = () => {
        setProductInfo(prev =>
            prev.filter((product, index) => {
                const productId = product._id?.toString() || product.id?.toString() || `product-${index}`;
                return !productsToRemove.includes(productId);
            })
        );
        setProductsToRemove([]);
    };

    useEffect(() => {
        setProductsToRemove([]);
    }, [showFilterType, productInfoFilters]);

    useEffect(() => {
        const filteredProductsData = selectedProducts.map((product, productIndex) => {
            const filteredProduct = {
                _id: product._id,
                displayName: product.displayName || '',
                productName: product.productName || '',
                modelNumber: product.modelNumber || '',
                attributes: selectedAttributes.map(attributeName => {
                    const attributeObject = product.attributes?.find((attr: any) => {
                        if (typeof attr === 'object' && attr.attributeName) {
                            return attr.attributeName === attributeName;
                        }
                        return false;
                    });

                    if (attributeObject) {
                        return {
                            attributeName: attributeObject.attributeName,
                            value: attributeObject.value || '-',
                            unit: attributeObject.unit || {},
                            _id: attributeObject._id || null
                        };
                    } else {
                        return {
                            attributeName: attributeName,
                            value: '-',
                            unit: {},
                            _id: null
                        };
                    }
                }).filter(attr => attr !== null)
            };
            return filteredProduct;
        });

        if (masterData) {
            const existingIds = new Set(productData.map((p: any) => p._id?.toString() || p.id?.toString()));
            const uniqueFilteredProducts = filteredProductsData.filter((p: any) => {
                const id = p._id?.toString() || p.id?.toString();
                return !existingIds.has(id);
            });
            setProductInfo([...productData, ...uniqueFilteredProducts]);
        } else {
            setProductInfo(filteredProductsData);
        }
    }, [selectedProducts, selectedAttributes, masterData, productData]);

    useEffect(() => {
        formik.setFieldValue("selectedChildModels", productsToRemove);
    }, [productsToRemove]);

    useEffect(() => {
        if (isEdit && masterData) {
            setKeyword(masterData.keyword)
            setProductInfo(productData)
            setMasterModel(masterData.masterModel)
            setUpdatedproductData(productData)
            setSelectedAttributes(masterData.selecteAttributes)
            setSelectedProductGroup(masterData?.selectedProductGroup);
            setTotalProductShown(masterData.ProductInfo.length);
            setSelectedBrand(masterData.brandName);
            setPowerGroups(masterData.powerGroups)
        }
    }, [masterData, isEdit, productData])

    useEffect(() => {
        formik.setFieldValue("keyword", keyword);
        formik.setFieldValue("masterModel", masterModel);
        formik.setFieldValue("selectedAttributes", selectedAttributes);
        formik.setFieldValue('productInfo', productInfo)
        formik.setFieldValue('powerGroups',powerGroups)
    }, [keyword, masterModel, selectedAttributes, productInfo , powerGroups]);

    useEffect(() => {
        const merged = productInfo.map((item, index) => {
            const { attributes, ...rest } = item;
            const matchedProduct = updatedproductData.find(
                (updItem: any) => updItem._id === item._id
            );
            const filteredAttributes = matchedProduct?.attributes?.filter((attr: any) =>
                selectedAttributes.includes(attr.attributeName)
            ) || attributes;
            return {
                ...rest,
                attributes: filteredAttributes
            };
        });
        setMergedData(merged);
    }, [productInfo, updatedproductData, selectedAttributes]);

    useEffect(() => {
        if (productInfo.length === 0) {
            setUniqueAttributes([]);
            return;
        }

        const productsWithAttributes = productInfo.filter(product =>
            product.attributes &&
            Array.isArray(product.attributes) &&
            product.attributes.length > 0
        );

        if (productsWithAttributes.length === 0) {
            setUniqueAttributes([]);
            return;
        }
        const allAttributeNames = productsWithAttributes
            .flatMap(product =>
                product.attributes.map((attr: any) => {
                    if (typeof attr === 'string') {
                        return attr;
                    }
                    if (typeof attr === 'object' && attr.attributeName) {
                        return attr.attributeName;
                    }
                    return null;
                })
            )
            .filter(name => name !== null && name !== undefined && name !== '');

        if (masterData?.ProductInfo?.length > 0) {
            const uniqueAttributeNames = Array.from(new Set(allAttributeNames));
            setUniqueAttributes(uniqueAttributeNames);
        }
    }, [productInfo, masterData]);
    // console.log("Unique attributes:", uniqueAttributes);
    /*  useEffect(() => {
         // console.log("Currently selected products for removal:", productsToRemove);
 
         if (productsToRemove && productsToRemove.length > 0) {
             removeProduct(productsToRemove)
                 .then(response => {
 
 
                 })
                 .catch(error => {
                     console.error("Error removing products:", error);
 
                 });
         }
     }, [productsToRemove]); */

    useEffect(() => {
        const updatedFilters = { ...productInfoFilters };
        let filtersChanged = false;

        Object.keys(productInfoFilters).forEach((attributeName: any) => {
            const currentFilterValue = productInfoFilters[attributeName];
            if (currentFilterValue && currentFilterValue.length > 0) {
                const uniqueValues = getUniqueValuesForProductInfoAttribute(attributeName);
                const validFilterValues = currentFilterValue.filter((value: string) => uniqueValues.includes(value));
                if (validFilterValues.length !== currentFilterValue.length) {
                    updatedFilters[attributeName] = validFilterValues;
                    filtersChanged = true;
                }
            }
        });

        if (filtersChanged) {
            setProductInfoFilters(updatedFilters);
        }
    }, [productInfo, productInfoFilters]);

    const getUniqueValuesForProductInfoAttribute = (attributeName: any) => {
        const values = new Set();

        productInfo.forEach(product => {
            const attributeValue = product.attributes?.find((attr: any) => {
                return typeof attr === 'object' && attr.attributeName === attributeName;
            });

            let displayValue = '-';
            if (attributeValue && attributeValue.value) {
                displayValue = normalizeAttributeValue(attributeValue.value);
            }

            const productId = product._id?.toString() || product.id?.toString();
            const updatedProduct = updatedproductData?.find((updatedProd) => {
                const updatedProductId = updatedProd._id?.toString() || updatedProd.id?.toString();
                return updatedProductId === productId;
            });

            if (updatedProduct && updatedProduct.attributes) {
                const updatedAttribute = updatedProduct.attributes.find((attr: any) => {
                    return typeof attr === 'object' && attr.attributeName === attributeName;
                });
                if (updatedAttribute && updatedAttribute.value) {
                    if (displayValue === '-' || !displayValue) {
                        displayValue = normalizeAttributeValue(updatedAttribute.value);
                    }
                }
            }

            values.add(displayValue);
        });

        const valuesArray = Array.from(values).sort((a: any, b: any) => {
            if (a === '-' && b !== '-') return -1;
            if (b === '-' && a !== '-') return 1;
            return a.localeCompare(b);
        });

        return valuesArray;
    };

    const handleProductInfoFilterChange = (attributeName: any, selectedValues: any[]) => {
        setProductInfoFilters(prev => ({
            ...prev,
            [attributeName]: selectedValues.map(item => item.value)
        }));
    };

    const handleEditProduct = (productId: string | number) => {
        const url = process.env.REACT_APP_BASE_URL + `/product/edit?q=${productId}`;
        window.open(url, '_blank');
    };

    const getFilteredProductInfo = () => {
        let filteredData = productInfo.filter(product => {
            const attributeMatch = Object.entries(productInfoFilters).every(([attributeName, selectedValues]) => {
                if (!selectedValues || selectedValues.length === 0) return true;

                const attribute = product.attributes?.find((attr: any) =>
                    attr.attributeName === attributeName
                );
                const value = attribute?.value ? normalizeAttributeValue(attribute.value) : '-';
                return selectedValues.some(filter => filter === value);
            });

            let searchMatch = true;
            if (productSearchTerm.trim()) {
                const searchLower = productSearchTerm.toLowerCase().trim();
                const productName = (product.displayName || product.productName || product.name || '').toLowerCase();
                const modelNumber = (product.modelNumber || '').toLowerCase();

                searchMatch = productName.includes(searchLower) || modelNumber.includes(searchLower);
            }

            return attributeMatch && searchMatch;
        });

        if (showFilterType === 'added') {
            filteredData = filteredData.filter(product => {
                const productId = product._id || product.id;
                return isProductInMasterData(productId) && !removedFromMaster.has(productId.toString());
            });
        } else if (showFilterType === 'notAdded') {
            filteredData = filteredData.filter(product => {
                const productId = product._id || product.id;
                return !isProductInMasterData(productId) || removedFromMaster.has(productId.toString());
            });
        }

        const uniqueProducts = new Map();
        filteredData.forEach(product => {
            const productId = product._id || product.id;
            if (!uniqueProducts.has(productId)) {
                uniqueProducts.set(productId, product);
            }
        });

        return Array.from(uniqueProducts.values());
    };

    const handleProductSearch = (searchTerm: string) => {
        setProductSearchTerm(searchTerm);
    };

    const resetProductInfoFilters = () => {
        setProductInfoFilters({});
        setProductSearchTerm("");
    };

    const handleRemoveSelectedProductsWithProductInfoFilterReset = () => {
        const notAddedCount = productsToRemove.filter(id => !isProductFromDatabase(id)).length;
        let warningMessage = notAddedCount > 0
            ? `You have selected ${notAddedCount} products that are not added to the master model, so they will not be affected by the remove functionality. Do you still want to remove the ${productsToRemove.length - notAddedCount} selected products from the master model?`
            : "Do you really want to remove the selected products from master model?";

        if (productsToRemove && productsToRemove.length > 0) {
            Swal.fire({
                title: "Are you sure?",
                text: warningMessage,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, remove them!",
                cancelButtonText: "Cancel"
            }).then((result) => {
                if (result.isConfirmed) {
                    setIsLoading(true);
                    removeProduct(masterData._id, productsToRemove)
                        .then(response => {
                            masterData.ProductInfo = masterData.ProductInfo.filter(
                                (productId: any) => !productsToRemove.includes(productId.toString())
                            );
                            setProductsToRemove([]);
                            resetProductInfoFilters();
                            setIsLoading(false);
                            Swal.fire({
                                title: "Removed!",
                                text: "Selected products have been removed.",
                                icon: "success",
                                timer: 2000,
                                showConfirmButton: false
                            });
                            if (onSyncEdit) {
                            onSyncEdit({
                                action: 'removeProducts',
                                removedProductIds: productsToRemove,
                                response: response
                            });
                        }
                            if (onFormDataChange) {
                                onFormDataChange({
                                    productInfo: productInfo,
                                    removedProducts: productsToRemove
                                });
                            }

                            setProductInfo(prev => [...prev]);
                        })
                        .catch(error => {
                            console.error("Error removing products:", error);
                            setIsLoading(false);
                            Swal.fire({
                                title: "Error!",
                                text: "Failed to remove products. Please try again.",
                                icon: "error"
                            });
                        });
                }
            });
        }
    };

    const handleProductUpdateSuccess = (updatedProducts: any) => {
        setProductInfo(prevProductInfo => {
            return prevProductInfo.map(product => {
                const updatedProduct = updatedProducts.find((updated: any) =>
                    (updated._id && updated._id === product._id) ||
                    (updated.id && updated.id === product.id)
                );
                return updatedProduct ? { ...product, ...JSON.parse(JSON.stringify(updatedProduct)) } : product;
            });
        });
        setUpdatedproductData(updatedProducts);
        if (onFormDataChange) {
            onFormDataChange({
                productInfo: updatedProducts
            });
        }
    };

    useEffect(() => {
        if (productData && productData.length > 0) {
            setProductInfo(productData);
            setUpdatedproductData(productData);
        }
    }, [productData]);

    const filterMultiSelectStyle = {
        multiSelectContainer: {
            border: "1px solid var(--bs-gray-100)",
        },
        searchBox: {
            minHeight: "42px",
            fontWeight: "400",
            height: "30px",
            maxHeight: "30px",
            display: "flex",
            alignItems: "center",
            minWidth: "100px",
            fontSize: "12px",
            Padding: "0px",
        },
        chips: {
            marginBottom: "0",
            height: "28px"
        },
    };

    const isProductFromDatabase = (productId: any) => {
        if (!masterData || !masterData.ProductInfo) {
            return false;
        }
        const exists = masterData.ProductInfo.some((item: any) =>
            item.toString() === productId.toString()
        );
        return exists;
    };

    const [removedFromMaster, setRemovedFromMaster] = useState(new Set());

    const handleRemoveSelectedProductsWithSeparateTracking = () => {
        if (productsToRemove && productsToRemove.length > 0) {
            Swal.fire({
                title: "Are you sure?",
                text: "Do you really want to remove the selected products from master model?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, remove them!",
                cancelButtonText: "Cancel"
            }).then((result) => {
                if (result.isConfirmed) {
                    setIsLoading(true);
                    removeProduct(masterData._id, productsToRemove)
                        .then(response => {
                            setRemovedFromMaster(prev => {
                                const newSet = new Set(prev);
                                productsToRemove.forEach(id => newSet.add(id));
                                return newSet;
                            });
                            setSelectedProducts(prev =>
                                prev.filter(p => !productsToRemove.includes(p._id || p.id))
                            );
                            setProductsToRemove([]);
                            resetProductInfoFilters();
                            setIsLoading(false);
                            Swal.fire("Removed!", "Selected products have been removed.", "success");
                        })
                        .catch(error => {
                            console.error("Error removing products:", error);
                            setIsLoading(false);
                            Swal.fire({
                                title: "Error!",
                                text: "Failed to remove products. Please try again.",
                                icon: "error"
                            });
                        });
                }
            });
        }
    };

    const isProductFromDatabaseWithTracking = (productId: any) => {
        if (removedFromMaster.has(productId.toString())) {
            return false;
        }
        if (!masterData || !masterData.ProductInfo) {
            return false;
        }
        const exists = masterData.ProductInfo.some((item: any) =>
            item.toString() === productId.toString()
        );
        return exists;
    };

    const isProductInMasterData = (productId: string | number) => {
        return masterData?.ProductInfo?.some((item: any) =>
            item.toString() === productId.toString()
        ) || false;
    };

    const getAllUniqueAttributes = () => {
        const allAttributes = new Set();
        productInfo.forEach(product => {
            if (product.attributes && Array.isArray(product.attributes)) {
                product.attributes.forEach((attr: any) => {
                    if (attr && typeof attr === 'object' && attr.attributeName) {
                        allAttributes.add(attr.attributeName);
                    }
                });
            }
        });
        return Array.from(allAttributes);
    };
    useEffect(() => {
        if (masterData && masterData.powerGroups) {
            setPowerGroups(masterData.powerGroups);
        }
    }, [masterData]);

    const handleRemovePowerGroup = (groupToRemove: any) => {
        // Remove from powerGroups state
        setPowerGroups(prev => prev.filter(group => {
            const groupValue = typeof group === 'string' ? group : group.name || group.label;
            const removeValue = typeof groupToRemove === 'string' ? groupToRemove : groupToRemove.name || groupToRemove.label;
            return groupValue !== removeValue;
        }));

        // Add back to availablePowerValues if it exists in uniqueAcAdapterPowerValues
        const groupValueToAdd = typeof groupToRemove === 'string' ? groupToRemove : groupToRemove.name || groupToRemove.label;

        // Find the original power value from uniqueAcAdapterPowerValues that matches this group
        const originalPowerValue = uniqueAcAdapterPowerValues.find((val: any) => {
            // Remove count suffix to compare
            const valueWithoutCount = val.replace(/\s\(\d+\)$/, '').trim();
            return valueWithoutCount === groupValueToAdd;
        });

        if (originalPowerValue) {
            setAvailablePowerValues(prev => {
                // Only add if it's not already in the available list
                if (!prev.includes(originalPowerValue)) {
                    return [...prev, originalPowerValue];
                }
                return prev;
            });
        }
    };
  

    // console.log(masterData, "masterData")
    return (
        <>
            {isLoading && (
                <div className="overlay-loader">
                    <div className="loader-container">
                        <div className="spinner"></div>
                        <div className="loader-text">Searching products...</div>
                    </div>
                </div>
            )}
            <div className="pb-0 w-100" style={{ marginBottom: "20px" }}>
                <div className="w-100 px-0 p-0 m-0 gap-2" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div className="row w-100">
                        <div className="col-md-12 p-5 card w-100" style={{ position: "sticky" }}>
                            <MasterModelSelector
                                onMasterModelChange={(model: any) => setMasterModel(model)}
                                formik={formik}
                                isEdit={true}
                                masterData={masterData}
                                onFormDataChange={({ keyword }) => setKeyword(keyword)}
                                onSyncEdit={onSyncEdit}
                                data={data}
                                showSyncButton={true}


                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="card p-5 " style={{ marginTop: "20px" }}>
                <div className="row mb-4">
                    <div className="col-md-6">
                        <label className="form-label fs-6 fw-bolder text-dark required text-muted">
                            Select Brand
                        </label>
                        <Multiselect
                            options={allBrand}
                            displayValue="brandName"
                            placeholder="Select Brand"
                            hidePlaceholder={true}
                            selectedValues={masterData && masterData.brandName ? [masterData.brandName] : []}
                            selectionLimit={1}
                            style={style}
                            showArrow={true}
                            customArrow={<CustomArrow />}
                            customCloseIcon={<CustomCrossButton />}
                            avoidHighlightFirstOption={true}
                            onSelect={handleBrandFilter}
                            disable={true}
                            selectedValueDecorator={(value: string, option: any) => {
                                return <span>{masterData?.brandName || value || 'Unknown'}</span>;
                            }}
                        />
                        <small className="text-muted">Enter a single keyword to identify this product</small>
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex align-items-center justify-content-start">
                            <label className="form-label fs-6 fw-bolder text-dark required text-muted">
                                Search Products To Select The Master Model
                            </label>
                        </div>
                        <Multiselect
                            options={allProductGroupsWithCount}
                            displayValue="labelWithCount"
                            selectionLimit={1}
                            selectedValues={masterData && masterData.productFamily ? [masterData.productFamily] : []}
                            showArrow={true}
                            placeholder="Select Model Group"
                            onSelect={(data) => handleProductFamilyFilter(data, 0)}
                            disable={true}
                            selectedValueDecorator={(value: string, option: any) => {
                                return <span>{masterData?.productFamily || value || 'Unknown'}</span>;
                            }}
                        />
                    </div>
                    <div className="col-md-12 mb-4 mt-2">
                        <div className="row">
                            {availablePowerValues.length > 0 && (
                                <div className="col-md-12">
                                    <div className="d-flex flex-wrap gap-2 mt-2">
                                        {availablePowerValues.map((powerValue: any, index: number) => (
                                            <div key={index} className="mb-2">
                                                <div
                                                    className="border btn rounded text-center py-2 px-5 bg-secondary text-info"
                                                    onClick={() => handleSelectPowerValue(powerValue)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <div className="fw-semibold">{powerValue}</div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {powerGroups && powerGroups.length > 0 && (
                                <div className="col-md-12 mt-2">
                                    <h6 className="mb-3">Selected Power Groups</h6>
                                    <div className="border rounded p-3" style={{ minHeight: '50px', backgroundColor: '#f8f9fa' }}>
                                        <div className="d-flex flex-wrap gap-2">
                                            {powerGroups.map((group, index) => (
                                                <div key={index} className="mb-2">
                                                    <div className="border btn-success btn rounded text-center py-2 px-3 d-flex align-items-center gap-2">
                                                        <span className="fw-semibold">
                                                            {typeof group === 'string' ? group : group.name || group.label || JSON.stringify(group)}
                                                        </span>
                                                        <span
                                                            className="badge bg-light text-dark rounded-circle"
                                                            onClick={() => handleRemovePowerGroup(group)}
                                                            style={{ cursor: 'pointer', fontSize: '12px' }}
                                                            title="Remove this power group"
                                                        >
                                                            ×
                                                        </span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="mt-2">
                                        <small className="text-muted">
                                            Selected: {powerGroups.length} group(s)
                                        </small>
                                    </div>
                                </div>

                            )}
                            <div className="col-md-12 mt-3">
                                <button
                                    type="button"
                                    className="btn btn-primary float-end"
                                    onClick={() => handleAddPowerGroups(selectedBrand, powerGroups, 0, 100)}
                                >
                                    Add Selected Group Products
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card p-5 " style={{ marginTop: "20px" }}>
                <div className="row mb-4">
                   

                    <div className="col-md-12 p-5 mt-4">
                        <AttributeAccordion
                            attributeNames={uniqueAttributes}
                            selectedAttributes={selectedAttributes}
                            onAttributeSelection={handleAttributeSelection}
                            masterData={masterData}
                        />
                    </div>
                </div>
            </div>
            {selectedAttributes.length > 0 && selectedProductGroup?.label ? (
                <div className="card mt-5 mb-5" style={{ marginTop: "80px" }}>
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <div className="card-title m-0">
                            <h3 className="fw-bolder m-0">Child Models of <b>{selectedProductGroup?.label}</b></h3>
                        </div>
                        <div>
                            <select
                                className="form-select form-select-white w-100"
                                style={{ minWidth: "220px" }}
                                value={showFilterType}
                                onChange={(e) => setShowFilterType(e.target.value)}
                            >
                                <option value="all">Show All</option>
                                <option value="added">Show Already Added</option>
                                <option value="notAdded">Show Not Added</option>
                            </select>
                        </div>
                        <div className="legend-badges">
                            <div className="legend-badge">
                                <div className="badge-dot red"></div>
                                <span className="badge-text">Different value from master model</span>
                            </div>
                            <div className="legend-badge">
                                <div className="badge-dot " style={{
                                    backgroundColor: 'magenta',
                                    width: '10px',
                                    height: '10px',
                                    borderRadius: '50%',
                                    display: 'inline-block',
                                    marginRight: '6px'
                                }}></div>
                                <span className="badge-text">Value Updated By Master Model Attribute</span>
                            </div>
                        </div>
                        {productsToRemove.length > 0 && (
                            <button
                                className="btn btn-danger btn-sm"
                                onClick={handleRemoveSelectedProductsWithProductInfoFilterReset}
                            >
                                <i className="fas fa-trash me-1"></i>
                                Remove Selected ({productsToRemove.length})
                            </button>
                        )}
                    </div>
                    <div className="card-body p-3">
                        <div style={{ overflowX: "auto", minHeight: "200px", maxHeight: "400px" }}>
                            <table className="table p-4 mb-0">
                                <thead>
                                    <tr>
                                        <th className="fw-bold bg-white px-2" style={{ position: "sticky", top: "0px", width: "50px" }}>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                style={{ width: "18px", height: "18px" }}
                                                checked={areAllProductsSelectedForRemoval()}
                                                onChange={(e) => handleSelectAllForRemoval(e.target.checked)}
                                            />
                                        </th>
                                        <th className="fw-bold bg-white px-2" style={{ position: "sticky", top: "0px", width: "50px" }}>No.</th>
                                        <th className="fw-bold bg-white" style={{ whiteSpace: "wrap", minWidth: "250px", position: "sticky", top: "0px" }}>
                                            <div className="mb-3">
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Search by product name or model..."
                                                    value={productSearchTerm}
                                                    onChange={(e) => handleProductSearch(e.target.value)}
                                                    style={{
                                                        fontSize: "12px",
                                                        height: "42px",
                                                        border: "1px solid #ddd",
                                                        borderRadius: "5px",
                                                        maxWidth: "280px",
                                                    }}
                                                />
                                            </div>
                                            Select All / Deselect All
                                        </th>
                                        {getAllUniqueAttributes()
                                            .filter((attributeName) => selectedAttributes.includes(attributeName as any))
                                            .map((attributeName, index) => (
                                                <th
                                                    className="fw-bold bg-white"
                                                    key={index}
                                                    style={{ whiteSpace: "nowrap", position: "sticky", top: "0px" }}
                                                >
                                                    <h5 className="fw-bolder mb-3">{attributeName as string}</h5>
                                                    <Multiselect
                                                        options={getUniqueValuesForProductInfoAttribute(attributeName).map(value => ({
                                                            value,
                                                            displayValue: value === '-' ? 'Blank' : value
                                                        }))}
                                                        displayValue="displayValue"
                                                        placeholder="Filter Values"
                                                        hidePlaceholder={true}
                                                        style={filterMultiSelectStyle}
                                                        showArrow={true}
                                                        customArrow={<CustomArrow />}
                                                        customCloseIcon={<CustomCrossButton />}
                                                        avoidHighlightFirstOption={true}
                                                        onSelect={(selectedList) => handleProductInfoFilterChange(attributeName, selectedList)}
                                                        onRemove={(selectedList) => handleProductInfoFilterChange(attributeName, selectedList)}
                                                        selectedValues={productInfoFilters[attributeName as string]?.map((value: any) => ({
                                                            value,
                                                            displayValue: value === '-' ? 'Blank' : value
                                                        })) || []}
                                                    />
                                                </th>
                                            ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {getFilteredProductInfo().map((product, productIndex) => {
                                        const productId = product._id?.toString() || product.id?.toString() || `product-${productIndex}`;
                                        const isRemoved = removedFromMaster.has(productId.toString());
                                        const isInMaster = isProductInMasterData(productId) && !isRemoved;

                                        if (showFilterType === 'added' && !isInMaster) return null;
                                        if (showFilterType === 'notAdded' && isInMaster) return null;

                                        return (
                                            <tr key={`product-${productIndex}`}>
                                                <td style={{ width: "40px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        style={{ width: "18px", height: "18px" }}
                                                        checked={isProductSelectedForRemoval(productId)}
                                                        onChange={() => handleProductRemovalSelection(productId)}
                                                    />
                                                </td>
                                                <td className="fw-bold" style={{ whiteSpace: "wrap" }}>{productIndex + 1}</td>
                                                <td className="fw-bold" style={{ whiteSpace: "wrap", minWidth: "350px" }}>
                                                    <div className="d-flex align-items-center">
                                                        <i
                                                            className="fas fa-edit text-primary "
                                                            style={{ cursor: "pointer", fontSize: "14px" }}
                                                            title="Edit Product"
                                                            onClick={() => handleEditProduct(productId)}
                                                        ></i>
                                                        {isProductInMasterData(productId) && (
                                                            <i className="las la-random fs-5 ms-2" style={{ color: "#8B5CF6", fontWeight: "800" }}></i>
                                                        )}
                                                        <span className="ms-2">
                                                            {product.displayName || product.productName || product.name || `Product ${productIndex + 1}`}
                                                        </span>
                                                    </div>
                                                </td>
                                                {getAllUniqueAttributes()
                                                    .filter((attributeName: any) => selectedAttributes.includes(attributeName))
                                                    .map((attributeName, attrIndex) => {
                                                        const attributeValue = product.attributes?.find((attr: any) => {
                                                            return typeof attr === 'object' && attr.attributeName === attributeName;
                                                        });

                                                        let displayValue = '-';
                                                        if (attributeValue && attributeValue.value) {
                                                            displayValue = attributeValue.value;
                                                        }

                                                        // Check if this attribute has updateByMasterModel flag set to true
                                                        const hasUpdateByMasterModelFlag = attributeValue &&
                                                            typeof attributeValue === 'object' &&
                                                            attributeValue.updateByMasterModel === true;

                                                        const masterAttribute = masterModel.attributes?.find((attr: any) => {
                                                            return typeof attr === 'object' && attr.attributeName === attributeName;
                                                        });

                                                        const masterValue = masterAttribute && typeof masterAttribute === 'object' && masterAttribute !== null && 'value' in masterAttribute
                                                            ? normalizeAttributeValue((masterAttribute as any).value)
                                                            : '-';

                                                        const normalizedDisplayValue = normalizeAttributeValue(displayValue);

                                                        const updatedProduct = updatedproductData?.find((updatedProd) => {
                                                            const updatedProductId = updatedProd._id?.toString() || updatedProd.id?.toString();
                                                            return updatedProductId === productId;
                                                        });

                                                        let updatedValue = null;
                                                        let hasUpdatedUpdateByMasterModelFlag = false;

                                                        if (updatedProduct && updatedProduct.attributes) {
                                                            const updatedAttribute = updatedProduct.attributes.find((attr: any) => {
                                                                return typeof attr === 'object' && attr.attributeName === attributeName;
                                                            });
                                                            if (updatedAttribute && updatedAttribute.value) {
                                                                updatedValue = normalizeAttributeValue(updatedAttribute.value);
                                                                // Check updateByMasterModel flag in updated product as well
                                                                hasUpdatedUpdateByMasterModelFlag = updatedAttribute.updateByMasterModel === true;
                                                            }
                                                        }

                                                        const hasDifference = masterModel.attributes && masterModel.attributes.length > 0 && normalizedDisplayValue !== masterValue;
                                                        const hasUpdatedValue = updatedValue && updatedValue !== normalizedDisplayValue;

                                                        // Determine the color based on updateByMasterModel flag
                                                        let cellClassName = '';
                                                        let cellStyle: React.CSSProperties = { whiteSpace: "nowrap" };

                                                        if (hasUpdateByMasterModelFlag || hasUpdatedUpdateByMasterModelFlag) {
                                                            cellStyle = { ...cellStyle, color: '#FF00FF', fontWeight: 'bold' }; // Magenta color
                                                        } else if (hasDifference) {
                                                            cellClassName = 'text-danger fw-bold';
                                                        }

                                                        if (displayValue === '-' && updatedValue) {
                                                            const updatedHasDifference = masterModel.attributes && masterModel.attributes.length > 0 && updatedValue !== masterValue;

                                                            let updatedCellClassName = '';
                                                            let updatedCellStyle: React.CSSProperties = { whiteSpace: "nowrap" };

                                                            if (hasUpdatedUpdateByMasterModelFlag) {
                                                                updatedCellStyle = { ...updatedCellStyle, color: '#FF00FF', fontWeight: 'bold' }; // Magenta color
                                                            } else if (updatedHasDifference) {
                                                                updatedCellClassName = 'text-danger fw-bold';
                                                            }

                                                            return (
                                                                <td
                                                                    key={attrIndex}
                                                                    style={updatedCellStyle}
                                                                    className={updatedCellClassName}
                                                                >
                                                                    {updatedValue}
                                                                </td>
                                                            );
                                                        }

                                                        return (
                                                            <td
                                                                key={attrIndex}
                                                                style={cellStyle}
                                                                className={cellClassName}
                                                            >
                                                                {displayValue}
                                                                {hasUpdatedValue && (
                                                                    <span
                                                                        className="fw-bold ms-2"
                                                                        style={{
                                                                            color: hasUpdatedUpdateByMasterModelFlag ? '#FF00FF' : '#28a745' // Magenta if updateByMasterModel is true, otherwise green
                                                                        }}
                                                                    >
                                                                        → {updatedValue}
                                                                    </span>
                                                                )}
                                                            </td>
                                                        );
                                                    })}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div className="row mt-5">
                            <div className="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start dt-toolbar">
                                <div>
                                    <label className="fs-4">
                                        Displaying <b>{productInfo.length}</b> products — <b>{masterData.ProductInfo.length}</b> added and {productInfo.length - masterData.ProductInfo.length} not added
                                    </label>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end">
                                <label className="fs-4 me-3">Total Available Products {masterData?.productFamilyCount - (productInfo.length - masterData.productCount)}</label>
                                <div className="dt-paging paging_simple_numbers">
                                    {selectedProductGroup?.count > productInfo.length && (
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <label
                                                    className="input-group-text"
                                                    style={{ cursor: "pointer" }}  
                                                onClick={() => handleAddPowerGroups(selectedBrand , powerGroups, productInfo.length - masterData.productCount, perPageRecords)}

                                                    // onClick={() => handleProductFamilyFilter([selectedProductGroup], productInfo.length - masterData.productCount, perPageRecords)}
                                                    htmlFor="inputGroupSelect02"
                                                >
                                                    Add More Product
                                                </label>
                                            </div>
                                            <select
                                                className="form-select form-select-white"
                                                value={perPageRecords}
                                                id="inputGroupSelect02"
                                                onChange={(e) => setPerPageRecords(Number(e.target.value))}
                                            >
                                                <option value="100">100</option>
                                                <option value="200">200</option>
                                                <option value="300">300</option>
                                                <option value="500">500</option>
                                            </select>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="text-center mt-5 mb-5 text-muted">
                    {selectedProducts.length === 0 ? "No products selected" : "No attributes selected to display"}
                </div>
            )}
        </>
    );
};

export default EditMasterForm;